import React from 'react'
import PropTypes from 'prop-types'
import NRTFormInput from '../../../../../_common/_form/FormInput'
import { Validators } from '../../../../../_common/_form/Validators'


const QuestionOpenAnswer = (props) => {
    const code = props.code
    const answer = props.answer && props.answer[props.code]
    const disabled = props.isReview
    return (
        <div>

            <NRTFormInput
                name={code}
                value={answer}
                type={'textarea'}
                disabled={disabled}
                validators={[
                    Validators.required()
                ]}
            />

        </div>
    )
}

QuestionOpenAnswer.propTypes = {
    id: PropTypes.string,
}

QuestionOpenAnswer.defaultProps = {}

export default QuestionOpenAnswer



// WEBPACK FOOTER //
// ./src/components/_ead/_contentTypes/QuestionsNew/_components/Questions/QuestionOpenAnswer.js